// extracted by mini-css-extract-plugin
module.exports = {"unsubscribeButton":"Unsubscribe_unsubscribeButton__1NloH","successMessage":"Unsubscribe_successMessage__15U0D"};